import React from 'react';
import { makeStyles } from '@material-ui/core';
import { VisualizacaoContextProvider } from './Context';
import Display from './Display';
import Title from './Title';

const useStyles = makeStyles(() => ({
  '@global': {
    body: {
      margin: 0,
    },
  },
}));

function Visualizacao() {
  useStyles();
  return (
    <main>
      <VisualizacaoContextProvider>
        <Title />
        <Display />
      </VisualizacaoContextProvider>
    </main>
  );
}

export default Visualizacao;
